require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-test-into-code-401.json") })
        }
      }, "path---blog-how-to-test-into-code-401");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-test-into-code-401!./.cache/json/blog-how-to-test-into-code-401.json
// module id = 871
// module chunks = 231608221292675